/* eslint-disable max-lines */
/* eslint-disable id-length */
/* eslint-disable no-duplicate-imports */
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import homeIcon from '../../Assets/images/svg/dar_home.svg';
import usersIcon from '../../Assets/images/svg/dar_users.svg';
import masterIcon from '../../Assets/images/svg/dar_master.svg';
import lightBulbIcon from '../../Assets/images/svg/dar_bulb.svg';
import certificationsIcon from '../../Assets/images/svg/dar_certif.svg';
import selectedHomeIcon from '../../Assets/images/svg/dar_selected_home.svg';
import selectedMasterIcon from '../../Assets/images/svg/dar_selected_master.svg';
import selectedUsersIcon from '../../Assets/images/svg/dar_selected_users.svg';
import permissionIcon from '../../Assets/images/svg/permission.svg';
import selectedPermissionIcon from '../../Assets/images/svg/selected_permission.svg';
import selectedMapSkillIcon from '../../Assets/images/svg/dar_selected_map_skill.svg';
import selectedMapCertificationsIcon from '../../Assets/images/svg/dar_selected_map_cert.svg';
import dealTransition from '../../Assets/images/svg/dar_deal_transition_icon.svg';
import selectedDealTransition from '../../Assets/images/svg/dar_selected_deal_transition_icon.svg';
import configurationIcon from '../../Assets/images/svg/wrench .svg';
import selectedConfigurationIcon from '../../Assets/images/svg/wrench_Blue.svg';
import DesktopSideBar from './Desktop/desktop';
import MobileSideBar from './Mobile/mobile';
import { AuthContext } from '../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../Constants/modules';
import misIcon from '../../Assets/images/svg/dar_collections_dashboard.svg';
import selectedMisIcon from '../../Assets/images/svg/dar_selected_collections_dashboard.svg';
import selectedStaffAugmentation from '../../Assets/images/svg/dar_selected_staff_augmentation.svg';
import staffAugmentation from '../../Assets/images/svg/dar_staff_augmentation.svg';
import mainDeliveryIcon from '../../Assets/images/svg/delivery_icon.svg';
import selectedMainDeliveryIcon from '../../Assets/images/svg/selected_delivery_icon.svg';
import OrgContributionIcon from '../../Assets/images/svg/org_contribution_icon.svg';
import selectedOrgContributionIcon from '../../Assets/images/svg/selected_org_contribution_icon.svg';
import financeIcon from '../../Assets/images/svg/finance_icon.svg';
import selectedFinanceIcon from '../../Assets/images/svg/selected_finance_icon.svg';
import projectIcon from '../../Assets/images/svg/dar_projects_icon.svg';
import selectedProjectIcon from '../../Assets/images/svg/dar_selected_projects_icon.svg';
import resourceIcon from '../../Assets/images/svg/dar_resource.svg';
import selectedResourceIcon from '../../Assets/images/svg/selected_dar_resource.svg';

export const menuItems = [
  {
    id: 1,
    icon: homeIcon,
    selectedIcon: selectedHomeIcon,
    text: 'Home',
    link: '/home',
    submenuItems: [],
    moduleName: MODULE_NAMES.HOME_DASHBOARD,
  },
  {
    id: 2,
    icon: masterIcon,
    selectedIcon: selectedMasterIcon,
    text: 'Masters',
    submenuItems: [
      {
        id: 21,
        text: 'Delivery',
        submenuOptions: [
          {
            id: 211,
            text: 'Role',
            link: 'masters/role',
            moduleName: MODULE_NAMES.MASTER_DELIVERY_ROLE,
          },
        ],
      },
      {
        id: 22,
        text: 'Training',
        submenuOptions: [
          {
            id: 221,
            text: 'Skill',
            link: 'masters/skill',
            moduleName: MODULE_NAMES.MASTER_TRAINING_SKILL,
          },
          {
            id: 222,
            text: 'Certification Category',
            link: 'masters/certification-category',
            moduleName: MODULE_NAMES.MASTER_TRAINING_CERT_CATEGORY,
          },
          {
            id: 223,
            text: 'Certification',
            link: 'masters/certification',
            moduleName: MODULE_NAMES.MASTER_TRAINING_CERTIFICATION,
          },
        ],
      },
      {
        id: 23,
        text: 'Performance',
        submenuOptions: [
          {
            id: 231,
            text: 'Declare performance period',
            link: '/masters/performance/period',
            moduleName: MODULE_NAMES.MASTER_PERFORMANCE_PERIOD,
          },
          {
            id: 232,
            text: 'Declare source & remark',
            link: '/masters/performance/source-remarks',
            moduleName: MODULE_NAMES.MASTER_REMARKS,
          },
        ],
      },
      {
        id: 24,
        text: 'Deal Transition',
        submenuOptions: [
          {
            id: 241,
            text: 'Deal status',
            link: 'masters/deal-status',
            moduleName: MODULE_NAMES.MASTER_DEAL_STATUS,
          },
          {
            id: 242,
            text: 'Deal role',
            link: '/masters/deal-role',
            moduleName: MODULE_NAMES.MASTER_DEAL_ROLE,
          },
          {
            id: 243,
            text: 'Parameters',
            link: '/masters/parameters',
            moduleName: MODULE_NAMES.MASTER_DEAL_PARAMETERS,
          },
          {
            id: 244,
            text: 'Efforts',
            link: '/masters/efforts',
            moduleName: MODULE_NAMES.MASTER_DEAL_EFFORTS,
          },
          {
            id: 245,
            text: 'Cost',
            link: '/masters/cost',
            moduleName: MODULE_NAMES.MASTER_COST_MASTER,
          },
        ],
      },
      {
        id: 25,
        text: 'StaffAug status',
        submenuOptions: [
          {
            id: 251,
            text: 'Requirement status',
            link: 'masters/requirement-status',
            moduleName: MODULE_NAMES.MASTER_STAFFAUG_REQUIREMENT_STATUS,
          },
          {
            id: 252,
            text: 'Client interview status',
            link: 'masters/client-interview-status',
            moduleName: MODULE_NAMES.MASTER_STAFFAUG_CLIENT_INTERVIEW,
          },
          {
            id: 253,
            text: 'Lost/ Dropped Status',
            link: 'masters/lost-dropped-status',
            moduleName: MODULE_NAMES.MASTER_STAFFAUG_LOST_DROPPED_STATUS,
          },
          {
            id: 254,
            text: 'Geography',
            link: 'masters/geography',
            moduleName: MODULE_NAMES.MASTER_STAFFAUG_GEOGRAPHY,
          },
        ],
      },
      {
        id: 26,
        text: 'Configuration',
        submenuOptions: [
          {
            id: 261,
            link: '/configuration/cloud-provider',
            text: 'Cloud Provider',
            moduleName: MODULE_NAMES.CONFIGURATION_CLOUD_PROVIDER,
          },
          {
            id: 262,
            link: '/configuration/region-list',
            text: 'Region List',
            moduleName: MODULE_NAMES.MASTERS_REGION_LIST,
          },
          {
            id: 263,
            link: '/masters/configuration/allocation-stakeholders',
            text: 'Allocation Stakeholders',
            moduleName: MODULE_NAMES.MASTER_ALLOCATION_STAKE_HOLDERS,
          },
          {
            id: 264,
            link: '/configuration/billing-type',
            text: 'Billing Type',
            moduleName: MODULE_NAMES.CONFIGURATION_BILLING_TYPE,
          },
          {
            id: 265,
            link: '/configuration/department-list',
            text: 'Department List',
            moduleName: MODULE_NAMES.CONFIGURATION_DEPARTMENT_LIST,
          },
          {
            id: 266,
            link: '/configuration/employee-experience',
            text: 'Employee Experience',
            moduleName: MODULE_NAMES.CONFIGURATION_EMPLOYEE_EXPERIENCE,
          },
          {
            id: 267,
            link: '/configuration/country-list',
            text: 'Country List',
            moduleName: MODULE_NAMES.MASTERS_COUNTRY_LIST,
          },
          {
            id: 268,
            link: '/configuration/delivery-methodology',
            text: 'Delivery Methodology',
            moduleName: MODULE_NAMES.MASTERS_DELIVERY_METHODOLGY,
          },
          {
            id: 269,
            link: '/configuration/invoice-payment-status',
            text: 'Invoice Payment Status',
            moduleName: MODULE_NAMES.CONFIGURATION_INVOICE_PAYMENT_STATUS,
          },
          {
            id: 270,
            link: '/configuration/employee-vertical',
            text: 'Employee Vertical',
            moduleName: MODULE_NAMES.CONFIGURATION_EMPLOYEE_VERTICAL,
          },
          {
            id: 271,
            link: '/configuration/invoice-status',
            text: 'Invoice Status',
            moduleName: MODULE_NAMES.CONFIGURATION_INVOICE_STATUS,
          },
          {
            id: 272,
            link: '/configuration/invoice-type',
            text: 'Invoice Type',
            moduleName: MODULE_NAMES.MASTERS_INVOICE_TYPE,
          },
          {
            id: 273,
            link: '/configuration/issue-category',
            text: 'Issue Categories',
            moduleName: MODULE_NAMES.CONFIGURATION_ISSUE_CATEGORY,
          },
          {
            id: 274,
            link: '/configuration/issue-status',
            text: 'Issue Status',
            moduleName: MODULE_NAMES.CONFIGURATION_ISSUE_STATUS,
          },
        ],
      },
    ],
  },
  {
    id: 3,
    icon: usersIcon,
    selectedIcon: selectedUsersIcon,
    text: 'Users',
    link: '/users',
    submenuItems: [],
    moduleName: MODULE_NAMES.CONFIGURATION_USER,
  },
  {
    id: 4,
    icon: lightBulbIcon,
    selectedIcon: selectedMapSkillIcon,
    text: 'Skills',
    submenuItems: [],
    link: '/skills',
    moduleName: MODULE_NAMES.CONFIGURATION_SKILL,
  },
  {
    id: 5,
    icon: certificationsIcon,
    selectedIcon: selectedMapCertificationsIcon,
    text: 'Certifications',
    submenuItems: [
      {
        id: 51,
        text: 'Overview',
        link: 'certifications/overview',
        moduleName: MODULE_NAMES.CERTIFICATION_OVERVIEW,
      },
      {
        id: 52,
        text: 'Map',
        link: 'certifications/map',
        moduleName: MODULE_NAMES.CERTIFICATION_MAP,
      },
      {
        id: 53,
        text: 'Target',
        link: 'certifications/target',
        moduleName: MODULE_NAMES.CERTIFICATION_TARGET,
      },
    ],
  },
  {
    id: 6,
    icon: configurationIcon,
    selectedIcon: selectedConfigurationIcon,
    text: 'Configuration',
    submenuItems: [
      {
        id: 61,
        text: 'Manage KPI',
        link: '/configuration/manage-kpi',
        moduleName: MODULE_NAMES.CONFIGURATION_MANAGE_KPI,
      },
      {
        id: 62,
        text: 'Data upload',
        submenuOptions: [
          {
            id: 621,
            text: 'Effort upload',
            link: '/configuration/data-upload/effort-upload',
            moduleName: MODULE_NAMES.CONFIGURATION_EFFORT_UPLOAD,
          },
          {
            id: 622,
            text: 'Leave upload',
            link: '/configuration/data-upload/leave-upload',
            moduleName: MODULE_NAMES.CONFIGURATION_LEAVE_UPLOAD,
          },
          {
            id: 623,
            text: 'File upload',
            link: '/configuration/data-upload/file-upload',
            moduleName: MODULE_NAMES.CONFIGURATION_FILE_UPLOAD,
          },
        ],
      },
      {
        id: 63,
        link: '/configuration/date-config',
        moduleName: MODULE_NAMES.CONFIGURATION_DATE_CONFIG,
        text: 'Date config',
      },
    ],
  },
  {
    id: 7,
    icon: permissionIcon,
    selectedIcon: selectedPermissionIcon,
    text: 'Permissions',
    link: '/permissions',
    submenuItems: [],
    moduleName: MODULE_NAMES.PERMISSION,
  },
  {
    id: 8,
    icon: dealTransition,
    selectedIcon: selectedDealTransition,
    text: 'Deal transition',
    submenuItems: [
      {
        id: 81,
        text: 'Dashboard',
        link: '/deal-transition/dashboard',
        moduleName: MODULE_NAMES.DEAL_TRANSITION_DASHBOARD,
      },
      {
        id: 82,
        text: 'Workflow',
        link: '/deal-transition/workflow',
        moduleName: MODULE_NAMES.DEAL_TRANSITION_WORKFLOW,
      },
      {
        id: 83,
        text: 'SLA tracker',
        link: '/deal-transition/dashboard',
        moduleName: MODULE_NAMES.DEAL_TRANSITION_SLO,
      },
      {
        id: 84,
        text: 'Staffing',
        link: '/deal-transition/staffing',
        moduleName: MODULE_NAMES.DEAL_TRANSITION_STAFFING,
      },
      {
        id: 85,
        text: 'Revenue',
        link: '/deal-transition/revenue',
        moduleName: MODULE_NAMES.DEAL_TRANSITION_REVENUE,
      },
      {
        id: 86,
        text: 'Deal Approval',
        submenuOptions: [
          {
            id: 861,
            text: 'Deal Effort Approval',
            link: '/deal-transition/deal-approval/effort-approval',
            moduleName: MODULE_NAMES.DEAL_TRANSITION_DEAL_EFFORT_APPROVAL,
          },
          {
            id: 862,
            text: 'Deal Financial Approval',
            link: '/deal-transition/deal-approval/financial-approval',
            moduleName: MODULE_NAMES.DEAL_TRANSITION_DEAL_FINANCIAL_APPROVAL,
          },
        ],
      },
    ],
  },
  {
    id: 9,
    icon: staffAugmentation,
    selectedIcon: selectedStaffAugmentation,
    text: 'Staff-Aug',
    submenuItems: [
      {
        id: 91,
        text: 'Requirement',
        link: '/staff-augmentation/requirement',
        submenuItems: [],
        moduleName: MODULE_NAMES.STAFF_AUG_REQ_STATUS,
      },
    ],
  },
  {
    id: 10,
    icon: OrgContributionIcon,
    selectedIcon: selectedOrgContributionIcon,
    text: 'Organization Contribution',
    submenuItems: [
      {
        id: 101,
        text: 'Tech Session',
        submenuOptions: [
          {
            id: 1011,
            text: 'Calendar',
            link: 'tech-session/calendar',
            submenuItems: [],
            moduleName: MODULE_NAMES.TECH_SESSION_CALENDAR,
          },
          {
            id: 1012,
            text: 'Signup',
            link: 'tech-session/signup',
            submenuItems: [],
          },
          {
            id: 1013,
            text: 'Users',
            link: 'tech-session/new-request',
            submenuItems: [],
            moduleName: MODULE_NAMES.TECH_SESSION_NEW_REQUEST,
          },
          {
            id: 1014,
            text: 'Received request',
            link: '/tech-session/received-request',
            submenuItems: [],
            moduleName: MODULE_NAMES.TECH_SESSION_RECEIVED_REQUEST,
          },
        ],
      },
      {
        id: 102,
        text: 'Blogs',
        link: '/blogs',
        submenuItems: [],
        moduleName: MODULE_NAMES.ORGANIZATION_BLOGS,
      },
    ],
  },
  {
    id: 11,
    icon: financeIcon,
    selectedIcon: selectedFinanceIcon,
    text: 'Finance',
    submenuItems: [
      {
        id: 111,
        text: 'Milestone',
        link: '/finance/milestone-details',
        submenuItems: [],
        moduleName: MODULE_NAMES.FINANCE_MILESTONE,
      },
      {
        id: 112,
        text: 'Client Details',
        link: '/finance/client-details',
        moduleName: MODULE_NAMES.FINANCE_CLIENT_DETAILS,
      },
      {
        id: 113,
        text: 'Po Details',
        link: '/finance/po-details',
        moduleName: MODULE_NAMES.FINANCE_PO_DETAILS,
      },
      {
        id: 114,
        text: 'Zoho Invoice Details',
        link: '/finance/zoho-invoice-details',
        moduleName: MODULE_NAMES.FINANCE_ZOHO_INVOICE_DETAILS,
      },
      {
        id: 115,
        text: 'Zoho Client Details',
        link: '/finance/zoho-client-details',
        moduleName: MODULE_NAMES.FINANCE_ZOHO_CUSTOMER_DETAILS,
      },
      {
        id: 116,
        text: 'Employee Cost Details',
        link: '/finance/employee-cost-details',
        submenuItems: [],
        moduleName: MODULE_NAMES.FINANCE_EMPLOYEE_COST,
      },
    ],
  },
  {
    id: 12,
    icon: mainDeliveryIcon,
    selectedIcon: selectedMainDeliveryIcon,
    text: 'Delivery',
    submenuItems: [
      {
        id: 121,
        text: 'Project overview',
        link: '/delivery/project-overview',
        submenuItems: [],
        moduleName: MODULE_NAMES.DELIVERY_PROJECT_OVERVIEW,
      },
      {
        id: 122,
        text: 'Staffing Request',
        link: '/delivery/staffing-request',
        submenuItems: [],
        moduleName: MODULE_NAMES.DELIVERY_ADD_STAFFING_REQUEST,
      },
      {
        id: 123,
        text: 'Project Info Lookup',
        link: '/delivery/project-info-lookup',
        submenuItems: [],
        moduleName: MODULE_NAMES.DELIVERY_PROJECT_INFO_LOOKUP,
      },
      {
        id: 124,
        text: 'Add projects',
        link: '/delivery/add-projects',
        submenuItems: [],
        requiredModulePermissions: [
          {
            moduleName: MODULE_NAMES.DELIVERY_ADD_PROJECTS,
            actions: ['create'],
          },
        ],
      },
    ],
  },
  {
    id: 13,
    icon: projectIcon,
    selectedIcon: selectedProjectIcon,
    text: 'Projects',
    submenuItems: [
      {
        id: 131,
        text: 'Change Request',
        link: '/projects/change-request',
        submenuItems: [],
        moduleName: MODULE_NAMES.PROJECT_CHANGE_REQUEST,
      },
      {
        id: 132,
        text: 'Timeline',
        link: '/projects/change-request/timeline',
        submenuItems: [],
        moduleName: MODULE_NAMES.PROJECT_TIMELINE_CHANGE_REQUEST,
      },
      {
        id: 133,
        text: 'Time Sheet Report',
        link: '/projects/time-sheet-report',
        submenuItems: [],
        moduleNames: [
          MODULE_NAMES.PROJECT_TIME_SHEET_REPORT_LIST_VIEW,
          MODULE_NAMES.PROJECT_TIME_SHEET_REPORT_CALENDAR_VIEW,
        ],
      },
      {
        id: 134,
        text: 'File Upload',
        link: '/project/file-upload',
        submenuItems: [],
        moduleNames: [
          MODULE_NAMES.PROJECT_FILE_UPLOAD_REDMINE,
          MODULE_NAMES.PROJECT_FILE_UPLOAD_LEAVE,
          MODULE_NAMES.PROJECT_FILE_UPLOAD_HOLIDAY,
          MODULE_NAMES.PROJECT_FILE_UPLOAD_LEAVE_TEST,
          MODULE_NAMES.PROJECT_FILE_UPLOAD_SALARY,
          MODULE_NAMES.PROJECT_FILE_UPLOAD_PROJECT_EXPENSE,
          MODULE_NAMES.PROJECT_FILE_UPLOAD_JIRA,
        ],
      },
    ],
  },
  {
    id: 14,
    icon: resourceIcon,
    selectedIcon: selectedResourceIcon,
    text: 'Resource',
    submenuItems: [
      {
        id: 141,
        text: 'Resource\nAllocation',
        link: '/resource/resource-allocation',
        submenuItems: [],
        moduleName: MODULE_NAMES.RESOURCE_RESOURCE_ALLOCATION,
      },
      {
        id: 142,
        text: 'Resource Management',
        link: '/resource/resource-management',
        submenuItems: [],
        moduleName: MODULE_NAMES.RESOURCE_RESOURCE_MANAGEMENT,
      },
      {
        id: 143,
        text: 'TBH Resource Management',
        link: '/resource/tbh-resource-management',
        moduleName: MODULE_NAMES.TBH_RESOURCE_MANAGEMENT,
      },
      {
        id: 144,
        text: 'Employee Management',
        link: '/resource/employee-management',
        submenuItems: [],
        moduleName: MODULE_NAMES.EMPLOYEE_MANAGEMENT_HISTORY,
      },
      {
        id: 145,
        text: 'TBH Employee Management',
        link: '/resource/tbh-employee-management',
        submenuItems: [],
        moduleName: MODULE_NAMES.RESOURCE_TBH_EMPLOYEE_MANAGEMENT,
      },
      {
        id: 146,
        text: 'Employee Management History',
        link: '/resource/manage-employee-history',
        moduleName: MODULE_NAMES.MANAGE_EMPLOYEE_HISTORY,
      },
      {
        id: 147,
        text: 'Project Rights',
        link: '/resource/project-rights',
        useRevenueStyles: true,
        moduleName: MODULE_NAMES.RESOURCE_PROJECT_RIGHTS,
      },
      {
        id: 148,
        text: 'Shift Allowance',
        link: '/resource/shift-allowance',
        submenuItems: [],
        moduleName: MODULE_NAMES.RESOURCE_SHIFT_ALLOWANCE,
      },
      {
        id: 149,
        text: 'AI Access Request',
        link: '/resource/ai-access-request',
        submenuItems: [],
        moduleNames: [MODULE_NAMES.RESOURCE_AI_ACCESS_REQUEST,
          MODULE_NAMES.RESOURCE_AI_ACCESS_REQUEST_APPROVAL,
        ],
      },
      {
        id: 150,
        text: 'AI Access Request DashBoard',
        link: '/resource/ai-access-request-dashboard',
        submenuItems: [],
        moduleNames: [MODULE_NAMES.RESOURCE_AI_ACCESS_REQ_DASHBOARD,
          MODULE_NAMES.RESOURCE_AI_ACCESS_REQ_DASHBOARD_SUMMARY,
        ],
      },
    ],
  },
  {
    id: 15,
    icon: misIcon,
    selectedIcon: selectedMisIcon,
    text: 'MIS',
    submenuItems: [
      {
        id: 1501,
        text: 'Employee MIS',
        link: '/mis/employee-mis',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_EMPLOYEE_DETAILS,
      },
      {
        id: 1502,
        text: 'Allocation MIS',
        link: '/mis/allocation-mis',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_ALLOCATION_MIS,
      },
      {
        id: 1503,
        text: 'Project Allocation %',
        link: '/mis/project-allocation',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_PROJECT_ALLOCATION,
      },
      {
        id: 1504,
        text: 'EDR Employee Effort',
        link: '/mis/edr-employee-effort',
        useRevenueStyles: true,
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_EDR_EMPLOYEE_EFFORT,
      },
      {
        id: 1505,
        text: 'EDR Project Effort',
        link: '/mis/edr-project-effort',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_EDR_PROJECT_EFFORT,
      },
      {
        id: 1506,
        text: 'EDR Activity Report',
        link: '/mis/edr-activity-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_EDR_ACTIVITY_REPORT,
      },
      {
        id: 1507,
        text: 'Utilization Employee Report',
        link: '/mis/employee-utilization-report',
        useRevenueStyles: true,
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_EMPLOYEE_UTILIZATION_REPORT,
      },
      {
        id: 1508,
        text: 'Utilization Activity Report',
        link: '/mis/activity-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_ACTIVITY_REPORT,
      },
      {
        id: 1509,
        text: 'Time Sheet MIS',
        link: '/mis/timesheet-mis',
        submenuItems: [],
        moduleNames: [
          MODULE_NAMES.MIS_TIME_SHEET_LIST_VIEW,
          MODULE_NAMES.MIS_TIME_SHEET_CALENDAR_VIEW_EMPLOYEE_WISE,
          MODULE_NAMES.MIS_TIME_SHEET_CALENDAR_VIEW_ACTIVITY_WISE,
        ],
      },
      {
        id: 1510,
        text: 'Delivery Utilization',
        link: '/mis/delivery-utilization-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_DELIVERY_UTILIZATION_REPORT,
      },
      {
        id: 1511,
        text: 'Project Utilization',
        link: '/mis/project-utilization',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_PROJECT_UTILIZATION,
      },
      {
        id: 1512,
        text: 'Milestone MIS',
        link: '/mis/milestone-mis',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_MILESTONE,
      },
      {
        id: 1513,
        text: 'PO MIS',
        link: '/mis/po-mis',
        submenuItems: [],
        moduleName: MODULE_NAMES.PO_MIS,
      },
      {
        id: 1514,
        text: 'Revenue MIS',
        link: '/mis/revenue-mis',
        useRevenueStyles: true,
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_REVENUE_MIS,
      },
      {
        id: 1515,
        text: 'Accrued Revenue Report',
        link: '/mis/accrued-revenue-report',
        useRevenueStyles: true,
        submenuOptions: [],
        moduleName: MODULE_NAMES.MIS_ACCRUED_REVENUE_REPORT,
      },
      {
        id: 1516,
        text: 'Revenue Recognition',
        link: '/mis/revenue-recognition',
        useRevenueStyles: true,
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_REVENUE_RECOGNITION,
      },
      {
        id: 1517,
        text: 'IRD',
        link: '/mis/imd-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_IMD_VIEW,
      },
      {
        id: 1518,
        text: 'Collection Report',
        link: '/mis/collection-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_COLLECTION_REPORT,
      },
      {
        id: 1519,
        text: 'Project Cost Report',
        link: '/mis/project-cost-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_PROJECT_COST_REPORT,
      },
      {
        id: 1520,
        text: 'Offering Wise Report',
        link: '/mis/offering-wise-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_OFFERING_WISE_REPORT,
      },
      {
        id: 1521,
        text: 'Project Employee Cost Report',
        link: '/mis/project-employee-cost',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_FINANCE_REPORT,
      },
      {
        id: 1522,
        text: 'Reseller Report',
        link: '/mis/reseller-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_RESELLER_REPORT,
      },
      {
        id: 1523,
        text: 'Staff Aug Report',
        link: '/mis/staff-aug-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_STAFF_AUG_REPORT,
      },
      {
        id: 1524,
        text: 'Risk Register',
        link: '/mis/risk-register',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_RISK_REGISTER,
      },
      {
        id: 1525,
        text: 'Health Check',
        submenuOptions: [
          {
            id: 15251,
            text: 'PMO',
            link: '/mis/health-check',
            submenuItems: [],
            moduleName: MODULE_NAMES.MIS_HEALTH_CHECK,
          },
          {
            id: 15252,
            text: 'Architecture',
            link: '/mis/health-check/architecture',
            submenuItems: [],
            moduleName: MODULE_NAMES.MIS_HEALTH_CHECK_ARCHITECTURE,
          },
        ],
      },
      {
        id: 1526,
        text: 'CSAT Customer Details',
        link: '/projects/csat-customer-details',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_CSAT_CUSTOMER_DETAILS,
      },
      {
        id: 1527,
        text: 'CSAT History',
        link: '/projects/csat-history',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_CSAT_HISTORY,
      },
      {
        id: 1528,
        text: 'Change Request',
        link: '/mis/change-request',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_CHANGE_REQUEST,
      },
      {
        id: 1529,
        text: 'Estimation VS Actual MIS',
        link: '/mis/estimated-vs-actual',
        useRevenueStyles: true,
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_ESTIMATED_VS_ACTUAL_REPORT,
      },
      {
        id: 1530,
        text: 'Staffing MIS',
        link: '/mis/staffing-mis',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_STAFFING_MIS,
      },
      {
        id: 1531,
        text: 'People Vs Project Count',
        link: '/mis/people-vs-project-count',
        submenuItems: [],
        moduleName: MODULE_NAMES.PEOPLE_VS_PROJECT_COUNT,
      },
      {
        id: 1532,
        text: 'Gross Margin Report',
        link: '/mis/gross-margin-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_GROSS_MARGIN_REPORT,
      },
      {
        id: 1533,
        text: 'Role Ratio Report',
        link: '/mis/role-ratio-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_ROLE_RATIO_REPORT,
        requiredModulePermissions: [{
          moduleName: MODULE_NAMES.MIS_ROLE_RATIO_REPORT,
          actions: ['read', 'view', 'update', 'edit'],
        }],
      },
      {
        id: 1534,
        text: 'Project Wise Salary Report',
        link: '/mis/projectwise-salary-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.PROJECT_WISE_SALARY_REPORT,
      },
      {
        id: 1535,
        text: 'Project Wise Expense Report',
        link: '/mis/project-wise-expense-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.PROJECT_WISE_EXPENSE_REPORT,
      },
      {
        id: 1537,
        text: 'Milestone Report',
        link: '/mis/milestone-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MILESTONE_REPORT,
      },
      {
        id: 1536,
        text: 'Shift Allowance',
        link: '/mis/shift-allowance',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_SHIFT_ALLOWANCE,
      },
      {
        id: 1538,
        text: 'Billing Report',
        link: '/mis/billing-report',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_BILLING_REPORT,
      },
      {
        id: 1539,
        text: 'AI Tool MIS',
        link: '/mis/ai-tool-mis',
        submenuItems: [],
        moduleName: MODULE_NAMES.MIS_AI_TOOL_MIS,
      },
    ],
  },
];

const filterMenuItem = (item, permissions = {}, isSuperAdmin = false) => {
  const safePermissions = permissions || {};

  if (isSuperAdmin || item.frontendOnly || item.skipPermission) {
    return {
      ...item,
      submenuItems: (item.submenuItems || [])
        .map((subItem) => filterMenuItem(subItem, safePermissions, isSuperAdmin))
        .filter(Boolean),
      submenuOptions: (item.submenuOptions || [])
        .map((subItem) => filterMenuItem(subItem, safePermissions, isSuperAdmin))
        .filter(Boolean),
    };
  }

  const moduleNamesList = item.moduleNames
    ? item.moduleNames
    : (item.moduleName ? [item.moduleName] : []);
  const requiredModulePermissions = item.requiredModulePermissions
    ? item.requiredModulePermissions
    : moduleNamesList.map((moduleName) => ({
      moduleName,
      actions: ['read', 'view'],
    }));

  const hasDirectPermission = requiredModulePermissions.some(({ moduleName, actions = ['read', 'view'] }) => {
    const normalizedActions = actions.map((action) => String(action).toLowerCase());
    const moduleCandidates = [
      moduleName,
      moduleName.replace(/-/g, '_'),
      moduleName.replace(/_/g, '-'),
    ];
    return moduleCandidates.some((candidate) => {
      const grantedActions = safePermissions[candidate];
      if (Array.isArray(grantedActions)) {
        return grantedActions.some((action) =>
          normalizedActions.includes(String(action).toLowerCase()),
        );
      }
      return normalizedActions.some((action) => (
        Object.prototype.hasOwnProperty.call(safePermissions, `${candidate}_${action}`)
        || Object.prototype.hasOwnProperty.call(safePermissions, `${candidate}:${action}`)
      ));
    });
  });

  // Filter submenus recursively
  const allowedSubmenuItems = (item.submenuItems || [])
    .map((subItem) => filterMenuItem(subItem, safePermissions, isSuperAdmin))
    .filter(Boolean);

  const allowedSubmenuOptions = (item.submenuOptions || [])
    .map((subItem) => filterMenuItem(subItem, safePermissions, isSuperAdmin))
    .filter(Boolean);

  // 1. If user has direct read/view permission for this item
  if (hasDirectPermission) {
    return {
      ...item,
      submenuItems: allowedSubmenuItems,
      submenuOptions: allowedSubmenuOptions,
    };
  }

  // 2. If it's a parent category (like 'Finance') with visible submodules
  if (allowedSubmenuItems.length > 0 || allowedSubmenuOptions.length > 0) {
    return {
      ...item,
      submenuItems: allowedSubmenuItems,
      submenuOptions: allowedSubmenuOptions,
    };
  }

  return null;
};

const checkPermission = (permissions = {}, isSuperAdmin = false) => {
  const allowedMenuItems = [menuItems[0]]; // Always include home menu item

  menuItems.slice(1).forEach((item) => {
    const allowedItem = filterMenuItem(item, permissions, isSuperAdmin);

    if (allowedItem) {
      allowedMenuItems.push(allowedItem);
    }
  });

  return allowedMenuItems;
};

const Sidebar = ({ isOpen, onToggle, screenWidth, Drawer }) => {
  const { userProfile } = useContext(AuthContext);
  const permissions = userProfile?.permissions;
  const isSuperAdmin = useMemo(() => {
    const rawLogin = String(
      userProfile?.login_type
      || userProfile?.loginType
      || userProfile?.Login_Type
      || userProfile?.user_type
      || '',
    ).trim();
    const loginType = rawLogin.toLowerCase();
    if (loginType === 'admin' || loginType === 'super admin') return true;

    const roleList = Array.isArray(userProfile?.roleDetails)
      ? userProfile.roleDetails
      : (userProfile?.roleDetails ? [userProfile.roleDetails] : []);

    return roleList.some((role) => {
      const rawRole = String(role?.roleName || role?.role_name || role?.name || '').trim();
      const name = rawRole.toLowerCase();
      const id = Number(role?.role_id ?? role?.roleId ?? role?.id);
      return name === 'super admin' || name === 'admin' || id === 1;
    });
  }, [userProfile]);

  const allowedMenuItems = useMemo(
    () => checkPermission(permissions, isSuperAdmin),
    [isSuperAdmin, permissions],
  );

  // DEBUG: log permissions and allowed menu for troubleshooting visibility
  try {
    // eslint-disable-next-line no-console
    console.debug('Sidebar: user permissions', permissions);
    // eslint-disable-next-line no-console
    console.debug('Sidebar: allowedMenuItems', allowedMenuItems.map((m) => m.text));
  } catch (e) {
    // ignore
  }

  // Temporary debug toggle: set `window.__SHOW_EMPLOYEE_COST = true` in browser console
  // then reload to force-show the Employee Cost submenu for troubleshooting.
  let effectiveAllowedMenuItems = allowedMenuItems;
  try {
    if (typeof window !== 'undefined' && window.__SHOW_EMPLOYEE_COST) {
      const financeMain = menuItems.find((m) => m.id === 9);
      const empSub = financeMain?.submenuItems?.find((s) => s.id === 92);
      if (empSub) {
        const hasFinance = effectiveAllowedMenuItems.some((m) => m.id === 9);
        if (!hasFinance) {
          effectiveAllowedMenuItems = [
            ...effectiveAllowedMenuItems,
            {
              ...financeMain,
              submenuItems: [empSub],
            },
          ];
        } else {
          effectiveAllowedMenuItems = effectiveAllowedMenuItems.map((m) => {
            if (m.id !== 9) return m;
            const has = (m.submenuItems || []).some((si) => si.id === 92);
            if (has) return m;
            return {
              ...m,
              submenuItems: [...(m.submenuItems || []), empSub],
            };
          });
        }
      }
    }
  } catch (e) {
    // ignore
  }

  return screenWidth ? (
    <DesktopSideBar
      menuItems={effectiveAllowedMenuItems}
      isOpen={isOpen}
      onToggle={onToggle}
      Drawer={Drawer}
    />
  ) : (
    <MobileSideBar
      menuItems={effectiveAllowedMenuItems}
      isOpen={isOpen}
      onToggle={onToggle}
      Drawer={Drawer}
    />
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  screenWidth: PropTypes.bool.isRequired,
  Drawer: PropTypes.elementType.isRequired,
};

export default Sidebar;
